import React from 'react'
import { PaypalBackgroundColorType } from 'src/shared/schemas/payment/paypal-background-color.schema'
import { PaypalLogo } from './paypal-logo'
import { PaypalLogoContainer } from './ui/paypal-logo-container'
import { PaypalPreviewButtonUi } from './ui/paypal-preview-button-ui'

interface PaypalPreviewButtonProps {
  type?: PaypalBackgroundColorType
  borderRadius?: number
}

const PAYPAL_PREVIEW_BUTTON_BG: Record<PaypalBackgroundColorType, string> = {
  gold: 'rgb(255, 196, 57)',
  blue: 'rgb(0, 112, 186)',
  silver: 'rgb(238, 238, 238)',
  white: 'rgb(255, 255, 255)',
  black: 'rgb(44, 46, 47)',
}

export const PaypalPreviewButton = ({
  type = 'blue',
  borderRadius = 3,
}: PaypalPreviewButtonProps) => (
  <PaypalPreviewButtonUi
    backgroundColor={PAYPAL_PREVIEW_BUTTON_BG[type]}
    borderRadius={borderRadius}
  >
    <PaypalLogoContainer>
      <PaypalLogo type={type} />
    </PaypalLogoContainer>
  </PaypalPreviewButtonUi>
)
